module.exports = __webpack_public_path__ + "img/collectRegularIcon.9bd31abc.png";